// Uclean-Admin-Dashboard/src/mocks/promo/_shared/ids.js
// UUID-shaped IDs for created rows in the mock store.
// Single ID factory across all promo resources.
// Combines Date.now() with a monotonic counter to avoid same-ms collisions.
// Example output: "00000000-0000-0000-0000-001234567890"

let counter = 0;

export function makeUuid() {
  counter = (counter + 1) % 1000;
  const ts = String(Date.now()).slice(-9);
  const seq = String(counter).padStart(3, '0');
  const suffix = (ts + seq).padStart(12, '0');
  return `00000000-0000-0000-0000-${suffix}`;
}
